import React from 'react';
import { useParams } from 'react-router-dom';
import BoardJobApplication from './BoardJobApplication';

const JobApplicationViewWrapper = () => {
  const { jobApplicationId } = useParams<{ jobApplicationId: string }>();
  return <BoardJobApplication jobApplicationId={jobApplicationId ? parseInt(jobApplicationId) : undefined} />;
};

export default JobApplicationViewWrapper;